import { AccountingChartAPI } from "../api"

export class AccountingChart {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
  }
  static async getAccountingCharts(projectId) {
    const { data } = await AccountingChartAPI.getAccountingCharts(projectId);
    return data.result.map((item) => (item = new AccountingChart(item)));
  }
  static async createAccountingChart(formData){
    const { data } = await AccountingChartAPI.createAccountingChart(formData);
    return new AccountingChart(data.result)
  }
  static async updateAccountingChart(formData){
    const { data } = await AccountingChartAPI.updateAccountingChart(formData);
    return new AccountingChart(data.result)
  }
}